import { css } from '@mui/material';

export const cssGlobal = css(css`
  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f0efef;
    overflow: hidden;
  }

  /* width */
  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  /* Track */
  *::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  /* Handle */
  *::-webkit-scrollbar-thumb {
    background: #bbb;
    border-radius: 10px;
  }

  /* Handle on hover */
  *::-webkit-scrollbar-thumb:hover {
    background: #aaa;
  }
`);
